<template>
    <div class="pos_scheduler_settings">
        <div class="scheduler-top row">
            <div class="col-12 col-md-6 mb-3">
                <yes_no
                    key="POS_SCHEDULER_ENABLED"
                    title="POS_SCHEDULER_ENABLED"
                    v-model="scheduler.enabled"
                    @input="emit_change"
                />
            </div>

            <div class="col-12 col-md-6 mb-3">
                <yes_no
                    key="POS_SCHEDULER_PUSH_TO_MARKETS"
                    title="POS_SCHEDULER_PUSH_TO_MARKETS"
                    v-model="scheduler.push_to_markets"
                    @input="emit_change"
                />
            </div>
        </div>

        <div class="scheduler-box">
            <div class="scheduler-box-title">
                {{ __t('POS_SCHEDULER_TIMES') }}
            </div>

            <div
                class="scheduler-day-row"
                v-for="(day, idx) in days"
                :key="day.key"
            >
                <div class="scheduler-day-head">
                    <div class="scheduler-day-name">
                        {{ day.title }}
                    </div>

                    <div class="scheduler-day-switch">
                        <yes_no
                            :key="'scheduler_day_' + day.key"
                            :title="' '"
                            v-model="scheduler.days[idx].enabled"
                            @input="emit_change"
                        />
                    </div>
                </div>

                <div
                    class="scheduler-day-body"
                    v-if="scheduler.days[idx].enabled"
                >
                    <div
                        class="scheduler-time-row"
                        v-for="(time, timeIdx) in scheduler.days[idx].times"
                        :key="timeIdx"
                    >
                        <div class="input-group input-group-md">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent">
                                    <i class="fal fa-clock"></i>
                                </span>
                            </div>

                            <b-form-input
                                type="time"
                                v-model="scheduler.days[idx].times[timeIdx]"
                                @change="emit_change"
                            />

                            <div class="input-group-append">
                                <button
                                    type="button"
                                    class="btn btn-outline-danger"
                                    @click="remove_time(idx, timeIdx)"
                                >
                                    <i class="fal fa-trash"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <button
                        type="button"
                        class="btn btn-sm btn-outline-primary mt-2"
                        @click="add_time(idx)"
                    >
                        <i class="fal fa-plus mr-1"></i>
                        {{ __t('ADD_TIME') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { createHelpers } from "vuex-map-fields";
import yes_no from "../../../sys/radio/yes_no.vue";

const { mapFields } = createHelpers({
    getterType: "pos/getPosStateField",
    mutationType: "pos/updatePosStateField",
});

export default {
    name: "pos_scheduler",

    components: {
        yes_no,
    },

    created() {
        this.init_scheduler();
    },

    methods: {
        init_scheduler() {
            if (!this.pos_item.basic_params.hasOwnProperty("scheduler")) {
                this.$set(this.pos_item.basic_params, "scheduler", this.default_scheduler());
                return;
            }

            if (!this.pos_item.basic_params.scheduler.hasOwnProperty("enabled")) {
                this.$set(this.pos_item.basic_params.scheduler, "enabled", false);
            }

            if (!this.pos_item.basic_params.scheduler.hasOwnProperty("push_to_markets")) {
                this.$set(this.pos_item.basic_params.scheduler, "push_to_markets", false);
            }

            if (!this.pos_item.basic_params.scheduler.hasOwnProperty("days")) {
                this.$set(this.pos_item.basic_params.scheduler, "days", this.default_scheduler().days);
            }

            for (let i = 0; i < 7; i++) {
                if (!this.pos_item.basic_params.scheduler.days.hasOwnProperty(i)) {
                    this.$set(this.pos_item.basic_params.scheduler.days, i, {
                        enabled: false,
                        times: []
                    });
                }

                if (!this.pos_item.basic_params.scheduler.days[i].hasOwnProperty("enabled")) {
                    this.$set(this.pos_item.basic_params.scheduler.days[i], "enabled", false);
                }

                if (!this.pos_item.basic_params.scheduler.days[i].hasOwnProperty("times")) {
                    this.$set(this.pos_item.basic_params.scheduler.days[i], "times", []);
                }
            }
        },

        default_scheduler() {
            return {
                enabled: false,
                push_to_markets: false,
                days: [
                    { enabled: false, times: [] }, // sun
                    { enabled: false, times: [] }, // mon
                    { enabled: false, times: [] }, // tue
                    { enabled: false, times: [] }, // wed
                    { enabled: false, times: [] }, // thurs
                    { enabled: false, times: [] }, // fri
                    { enabled: false, times: [] }, // sat
                ],
            };
        },

        add_time(dayIdx) {
            this.scheduler.days[dayIdx].times.push("07:00");
            this.emit_change();
        },

        remove_time(dayIdx, timeIdx) {
            this.scheduler.days[dayIdx].times.splice(timeIdx, 1);
            this.emit_change();
        },

        emit_change() {
            this.$emit("on_change", {
                key_name: "scheduler",
                key_val: this.scheduler,
                key_type: "general",
            });
        },
    },

    computed: {

        scheduler() {
            return this.pos_item.basic_params.scheduler;
        },

        days() {
            return [
                { key: "sun", title: this.__t("sun") },
                { key: "mon", title: this.__t("mon") },
                { key: "tue", title: this.__t("tue") },
                { key: "wed", title: this.__t("wed") },
                { key: "thurs", title: this.__t("thurs") },
                { key: "fri", title: this.__t("fri") },
                { key: "sat", title: this.__t("sat") },
            ];
        },

        ...mapFields([
            "pos_item",
        ]),
    },
};
</script>

<style scoped>
.pos_scheduler_settings {
    padding: 4px 0;
}

.scheduler-box {
    background: #f8f9fb;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 18px;
}

.scheduler-box-title {
    font-size: 14px;
    font-weight: 600;
    color: #6c757d;
    text-transform: uppercase;
    margin-bottom: 16px;
}

.scheduler-day-row {
    background: #fff;
    border: 1px solid #edf0f4;
    border-radius: 10px;
    padding: 14px 16px;
    margin-bottom: 12px;
}

.scheduler-day-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.scheduler-day-name {
    font-size: 16px;
    font-weight: 600;
    min-width: 90px;
    text-transform: lowercase;
}

.scheduler-day-switch {
    flex-shrink: 0;
}

.scheduler-day-body {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px dashed #e9ecef;
}

.scheduler-time-row {
    margin-bottom: 10px;
}

@media (max-width: 768px) {
    .scheduler-day-head {
        flex-direction: column;
        align-items: flex-start;
    }

    .scheduler-time-row {
        max-width: 100%;
    }
}
</style>
